import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Table, Form, Button, Spinner, Alert, Badge } from 'react-bootstrap';
import { FaFileExcel, FaSearch, FaExchangeAlt, FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import pythonApiClient from '../../../services/api/pythonBaseApi';

const ReporteModificacionesReservas = () => {
  const navigate = useNavigate();
  const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || 'null');

  const [filas, setFilas] = useState([]);
  const [resumen, setResumen] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filtros, setFiltros] = useState({
    fecha_desde: '',
    fecha_hasta: '',
    tipo_cambio: '',
    busqueda: '',
  });

  const loadReporte = async (filtrosOverride = null) => {
    if (!selectedProject?.id) return;
    const f = filtrosOverride || filtros;
    setLoading(true);
    setError(null);
    try {
      const params = {};
      if (f.fecha_desde) params.fecha_desde = f.fecha_desde;
      if (f.fecha_hasta) params.fecha_hasta = f.fecha_hasta;
      if (f.tipo_cambio) params.tipo_cambio = f.tipo_cambio;
      if (f.busqueda) params.busqueda = f.busqueda;

      const response = await pythonApiClient.get(
        '/reportes/hoteleria/modificaciones-reservas/',
        { params }
      );
      if (response.data.success) {
        setFilas(response.data.data || []);
        setResumen(response.data.resumen || null);
      } else {
        setError(response.data.message || 'No se pudo cargar el reporte');
      }
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.detail || 'No se pudo conectar con el servidor');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedProject?.id) loadReporte();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const exportToExcel = () => {
    const rows = filas.map((r) => ({
      'Fecha modificación': r.fecha_modificacion || '',
      'ID asignación': r.asignacion_id,
      DNI: r.dni || '',
      Trabajador: r.trabajador_nombre || '',
      'Tipo cambio': r.tipo_cambio || '',
      'Inicio anterior': r.fecha_inicio_anterior || '',
      'Inicio nueva': r.fecha_inicio_nueva || '',
      'Fin anterior': r.fecha_fin_anterior || '',
      'Fin nueva': r.fecha_fin_nueva || '',
      'Cambió entrada': r.cambio_fecha_entrada ? 'Sí' : 'No',
      'Cambió salida': r.cambio_fecha_salida ? 'Sí' : 'No',
      Motivo: r.motivo || '',
      Origen: r.origen || '',
      Usuario: r.usuario_nombre || '',
    }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(rows), 'Modificaciones');
    XLSX.writeFile(
      wb,
      `modificaciones_reservas_${selectedProject?.nombre || 'proyecto'}_${Date.now()}.xlsx`
    );
  };

  if (!selectedProject?.id) {
    return (
      <Container className="py-4">
        <Alert variant="warning">Seleccione un proyecto para ver el reporte.</Alert>
      </Container>
    );
  }

  return (
    <>
      <style>
        {`
          .dh-reporte-bg {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            min-height: 100vh;
            padding-bottom: 2rem;
          }
          .dh-card { border: none; border-radius: 20px; box-shadow: 0 10px 30px rgba(0,0,0,0.08); }
          .dh-card-header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            border-radius: 20px 20px 0 0 !important;
            padding: 1.25rem 1.5rem;
          }
          .dh-form-label { font-weight: 600; color: #374151; font-size: 0.85rem; }
          .dh-form-control {
            border-radius: 10px;
            border: 2px solid #e5e7eb;
          }
          .dh-form-control:focus {
            border-color: #667eea;
            box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.2);
          }
          .btn-dh-primary {
            background: linear-gradient(135deg, #10b981 0%, #059669 100%);
            border: none;
            color: white;
            border-radius: 10px;
            font-weight: 600;
          }
          .btn-dh-secondary {
            background: #6b7280;
            border: none;
            color: white;
            border-radius: 10px;
          }
          .btn-dh-success {
            background: linear-gradient(135deg, #059669 0%, #047857 100%);
            border: none;
            color: white;
            border-radius: 10px;
            font-weight: 600;
          }
          .dh-table thead {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
          }
          .dh-table thead th {
            border: none;
            padding: 12px 14px;
            font-weight: 600;
            font-size: 0.75rem;
            text-transform: uppercase;
          }
          .dh-table tbody td {
            padding: 10px 14px;
            vertical-align: middle;
            font-size: 0.875rem;
          }
        `}
      </style>

      <div className="dh-reporte-bg">
        <Container fluid className="px-4 pt-3">
          <Button
            className="btn-dh-secondary mb-3"
            onClick={() => navigate('/reportes')}
          >
            <FaArrowLeft className="me-2" />
            Volver a reportes
          </Button>

          <Card className="dh-card">
            <Card.Header className="dh-card-header">
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                <div className="d-flex align-items-center">
                  <FaExchangeAlt className="me-3" size={24} />
                  <div>
                    <h4 className="mb-0">Modificaciones de reservas</h4>
                    <small className="opacity-75">
                      Proyecto: {selectedProject.nombre} · Historial de cambios de fechas de
                      entrada/salida
                    </small>
                  </div>
                </div>
                <Button
                  className="btn-dh-success"
                  onClick={exportToExcel}
                  disabled={loading || filas.length === 0}
                >
                  <FaFileExcel className="me-2" />
                  Exportar Excel ({filas.length})
                </Button>
              </div>
            </Card.Header>
            <Card.Body className="p-4">
              <Card className="mb-4" style={{ border: '2px solid #e5e7eb', borderRadius: '15px' }}>
                <Card.Body>
                  <Row className="align-items-end g-2">
                    <Col md={2}>
                      <Form.Label className="dh-form-label">Desde (cambio)</Form.Label>
                      <Form.Control
                        type="date"
                        className="dh-form-control"
                        value={filtros.fecha_desde}
                        onChange={(e) =>
                          setFiltros((p) => ({ ...p, fecha_desde: e.target.value }))
                        }
                      />
                    </Col>
                    <Col md={2}>
                      <Form.Label className="dh-form-label">Hasta</Form.Label>
                      <Form.Control
                        type="date"
                        className="dh-form-control"
                        value={filtros.fecha_hasta}
                        onChange={(e) =>
                          setFiltros((p) => ({ ...p, fecha_hasta: e.target.value }))
                        }
                      />
                    </Col>
                    <Col md={2}>
                      <Form.Label className="dh-form-label">Tipo de cambio</Form.Label>
                      <Form.Select
                        className="dh-form-control"
                        value={filtros.tipo_cambio}
                        onChange={(e) =>
                          setFiltros((p) => ({ ...p, tipo_cambio: e.target.value }))
                        }
                      >
                        <option value="">Todos</option>
                        <option value="entrada">Solo entrada</option>
                        <option value="salida">Solo salida</option>
                      </Form.Select>
                    </Col>
                    <Col md={3}>
                      <Form.Label className="dh-form-label">Buscar</Form.Label>
                      <Form.Control
                        type="text"
                        className="dh-form-control"
                        placeholder="DNI, nombre, ID, motivo"
                        value={filtros.busqueda}
                        onChange={(e) =>
                          setFiltros((p) => ({ ...p, busqueda: e.target.value }))
                        }
                      />
                    </Col>
                    <Col md={2}>
                      <Button
                        className="btn-dh-primary w-100"
                        onClick={() => loadReporte()}
                        disabled={loading}
                      >
                        <FaSearch className="me-1" />
                        Buscar
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              {resumen && (
                <div className="mb-3 small">
                  Total: <strong>{resumen.total || 0}</strong> · Cambios entrada:{' '}
                  <strong>{resumen.cambios_entrada || 0}</strong> · Cambios salida:{' '}
                  <strong>{resumen.cambios_salida || 0}</strong> · Ambos:{' '}
                  <strong>{resumen.ambos || 0}</strong>
                </div>
              )}

              {error && (
                <Alert className="dh-alert dh-alert-info" variant="danger">
                  {error}
                </Alert>
              )}

              {loading ? (
                <div className="text-center py-5">
                  <Spinner animation="border" />
                </div>
              ) : (
                <div className="table-responsive">
                  <Table hover className="dh-table mb-0">
                    <thead>
                      <tr>
                        <th>Fecha modificación</th>
                        <th>Asignación</th>
                        <th>Trabajador</th>
                        <th>Tipo</th>
                        <th>Inicio ant. → nueva</th>
                        <th>Fin ant. → nueva</th>
                        <th>Motivo</th>
                        <th>Usuario</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filas.length === 0 ? (
                        <tr>
                          <td colSpan={8} className="text-center text-muted py-4">
                            No hay modificaciones con los filtros seleccionados
                          </td>
                        </tr>
                      ) : (
                        filas.map((r) => (
                          <tr key={r.id}>
                            <td>{r.fecha_modificacion || '—'}</td>
                            <td>{r.asignacion_id}</td>
                            <td>
                              <div>{r.trabajador_nombre || '—'}</div>
                              <small className="text-muted">{r.dni || ''}</small>
                            </td>
                            <td>
                              {r.cambio_fecha_entrada && (
                                <Badge bg="info" className="me-1">
                                  Entrada
                                </Badge>
                              )}
                              {r.cambio_fecha_salida && (
                                <Badge bg="warning" text="dark">
                                  Salida
                                </Badge>
                              )}
                            </td>
                            <td>
                              {r.cambio_fecha_entrada
                                ? `${r.fecha_inicio_anterior || '—'} → ${r.fecha_inicio_nueva || '—'}`
                                : '—'}
                            </td>
                            <td>
                              {r.cambio_fecha_salida
                                ? `${r.fecha_fin_anterior || '—'} → ${r.fecha_fin_nueva || '—'}`
                                : '—'}
                            </td>
                            <td>{r.motivo || '—'}</td>
                            <td>
                              <div>{r.usuario_nombre || '—'}</div>
                              <small className="text-muted">{r.origen || ''}</small>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </div>
              )}
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  );
};

export default ReporteModificacionesReservas;
